module.exports = __webpack_public_path__ + "static/media/Portrait-10060.a08c3407.jpg";